/**
 * Lightweight client-side fuzzy match (contains + single deletion/transposition).
 * Mirrors the admin API FuzzySearch near-match behavior for local-only tables.
 */
export function fuzzyIncludes(haystack, needle) {
  const text = String(haystack ?? "").toLowerCase();
  const q = String(needle ?? "").trim().toLowerCase();

  if (!q) return true;
  if (text.includes(q)) return true;
  if (q.length < 2) return false;

  for (let i = 0; i < q.length; i++) {
    const deleted = q.slice(0, i) + q.slice(i + 1);
    if (deleted.length >= 2 && text.includes(deleted)) return true;
  }

  for (let i = 0; i < q.length - 1; i++) {
    const chars = q.split("");
    [chars[i], chars[i + 1]] = [chars[i + 1], chars[i]];
    if (text.includes(chars.join(""))) return true;
  }

  return false;
}

export function fuzzyIncludesAny(haystacks, needle) {
  return haystacks.some((value) => fuzzyIncludes(value, needle));
}
